<template>
    <v-content>
        <v-row class="pb-0 pb-sm-2">
            <v-col class="display-1">
                Настройки
            </v-col>
            <v-col>
                <div class="float-right">
                    <v-btn color="primary" depressed @click="createItem()">
                        <v-icon small>mdi-plus</v-icon>
                        Добавить
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="4">
                <v-text-field
                    v-model="name"
                    @input="getSettings"
                    placeholder="Название"
                    outlined
                    hide-details
                    clearable
                    dense
                ></v-text-field>
            </v-col>
        </v-row>
        <b-table
            :data="settings.results"
            :loading="isLoading"
            paginated
            backend-pagination
            :total="settings.total"
            :per-page="perPage.value"
            @page-change="onPageChange"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            backend-sorting
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"
        >
            <template slot-scope="props">
                <b-table-column field="is_default" label="Default" centered>
                    <b-switch v-model="props.row.is_default" @input="setDefaultItem(props.row.id)"></b-switch>
                </b-table-column>

                <b-table-column field="id" label="ID" centered numeric sortable>
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column field="name" label="Название" centered sortable>
                    {{ props.row.name }}
                </b-table-column>

                <b-table-column field="description" label="Описание" centered>
                    {{ props.row.description }}
                </b-table-column>
                <b-table-column
                      label="Действия"
                      centered
                  >
                  <b-tooltip
                      label="Изменить">
                      <div
                          @click="editItem(props.row.id)">
                          <b-icon
                              icon="pencil"
                          ></b-icon>
                      </div>
                  </b-tooltip>
                  <b-tooltip
                      v-if="!props.row.is_default"
                      label="Удалить">
                      <div
                          @click="deleteItem(props.row.id)">
                          <b-icon
                              icon="delete"
                          ></b-icon>
                      </div>
                  </b-tooltip>
                </b-table-column>
            </template>
              <template slot="bottom-left">
                <div class="pagination-controls">
                  <v-select
                    style="width: fit-content; float: left;"
                    v-model="perPage.value"
                    @change="getSettings"
                    :items="perPageOptions"
                    item-text="name"
                    item-value="value"
                    outlined
                    hide-details
                    dense
                  />
                </div>
            </template>
        </b-table>
    </v-content>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
    name: 'AdminSettingsList',
    components: {
        OverlayLoader,
    },
    data() {
        return {
            sortField: "id",
            sortOrder: "desc",
            page: 1,
            perPage: {
                value: 20,
            },
            name: '',
            perPageOptions: [
                { name: "10 на странице", value: 10 },
                { name: "20 на странице", value: 20 },
                { name: "50 на странице", value: 50 },
                { name: "100 на странице", value: 100 },
            ],
        };
    },
    created() {
        this.getSettings();
    },
    computed: {
        settings() {
            return this.$store.getters.SETTINGS_LIST;
        },
        isLoading() {
            return this.$store.getters.SETTINGS_LOADING;
        },
    },
    methods: {
        editItem(settingsId) {
            this.$router.push({ name: "UpdateSettings", params: { id: settingsId } });
        },
        createItem() {
            this.$router.push({ name: "CreateSettings" });
        },
        setDefaultItem(settingsId) {
            this.$store.dispatch('SET_DEFAULT_SETTINGS', settingsId)
                .finally(() => this.getSettings());
        },
        deleteItem(settingsId) {
            this.$store.dispatch('DELETE_SETTINGS', settingsId)
                .finally(() => this.getSettings());
        },
        getSettings() {
            const params = {
                sort_by: this.sortField,
                order: this.sortOrder,
                page: this.page,
                perPage: this.perPage.value,
                name: this.name,
            };
            this.$store.dispatch('GET_SETTINGS_LIST', params);
        },
        onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.getSettings();
        },
        onPageChange(page) {
            this.page = page;
            this.getSettings();
        },
    }
}
</script>

<style>

</style>
